import React from 'react';
import { motion } from 'framer-motion';
export function HookSection() {
  return <section className="pt-6 pb-10 px-6 flex flex-col items-center text-center relative overflow-hidden" data-id="element-105">
      {/* Subtle background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-64 h-64 bg-copper/10 rounded-full blur-[80px] pointer-events-none" data-id="element-106" />

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.8
    }} className="max-w-md relative" data-id="element-107">
        {/* Decorative Quote Mark */}
        <div className="absolute -top-10 -left-6 text-8xl font-playfair text-copper/15 select-none pointer-events-none" data-id="element-108">
          "
        </div>

        <div className="relative z-10 space-y-6" data-id="element-109">
          <p className="font-playfair italic text-charcoal text-xl leading-relaxed opacity-80" data-id="element-110">
            You just got the plan.
            <br data-id="element-111" />
            You have the tools.
            <br data-id="element-112" />
            You know what to do.
          </p>

          <div className="w-8 h-[1px] bg-copper/20 mx-auto" data-id="element-113" />

          <p className="font-playfair italic text-charcoal text-xl leading-relaxed opacity-80" data-id="element-114">
            But knowing and doing — when you haven't slept, when your body is
            running on nothing, when the baby is finally down and your nervous
            system still won't stop firing —
          </p>

          <div className="w-8 h-[1px] bg-copper/20 mx-auto" data-id="element-115" />

          <p className="font-playfair text-2xl md:text-3xl leading-relaxed" data-id="element-116">
            <span className="italic text-charcoal opacity-90" data-id="element-117">
              Those are two completely different things.
            </span>
          </p>

          <div className="pt-8 pb-2" data-id="element-118">
            <span className="font-playfair text-3xl md:text-4xl font-medium bg-gradient-to-r from-[#7A4A20] via-[#C9A66B] to-[#7A4A20] bg-clip-text text-transparent block" data-id="element-119">
              This is the bridge."
            </span>
          </div>
        </div>
      </motion.div>
    </section>;
}